/**
 * Mixin for opening legal links (Privacy Policy and Terms of Use)
 * This mixin provides common methods for opening legal document links in a new window
 */

export const legalLinksMixin = {
  methods: {
    /**
     * Opens the privacy policy page in a new window
     */
    openPrivacyPolicy() {
      window.open('https://qesg.co.kr/terms/privacy_policy', '_blank');
    },

    /**
     * Opens the terms of use page in a new window
     */
    openTermsOfUse() {
      window.open('https://qesg.co.kr/terms/terms_of_use', '_blank');
    }
  }
};

export default legalLinksMixin;
